export default __webpack_public_path__ + "static/media/beveled-cube.3770ffd6.png";